import { useContext } from 'react';
import { Store } from './Store';
import { useQuery } from '@tanstack/react-query';

export function useCurrentUserSecurityQuery() {
    const {
        state: {
            user,
        },
    } = useContext(Store);

    const userId = user.id;

    return useQuery({
        queryKey: [ 'user.security', { userId } ],
        queryFn: async () => {
            user.security.limit = 24;
            await user.security.fetch([], false);

            const actorSecurityLink = user.security?.collection ?? [];
            return actorSecurityLink.reduce((security, link) => {
                if (link.securityrole.id) {
                    security.roles.push(link.securityrole);
                } else if (link.securitygroup.id) {
                    security.groups.push(link.securitygroup);
                }

                return security;
            }, {
                roles: [],
                groups: [],
            });
        },
        placeholderData: {
            roles: [],
            groups: [],
        },
    });
}
